import { render, staticRenderFns } from "./CommodityRegister.vue?vue&type=template&id=dd5f32bc"
import script from "./CommodityRegister.vue?vue&type=script&lang=js"
export * from "./CommodityRegister.vue?vue&type=script&lang=js"
import style0 from "./CommodityRegister.vue?vue&type=style&index=0&id=dd5f32bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports